import { atom } from 'jotai';
import { useAuth } from '@clerk/clerk-react';
import { createStore } from 'jotai';
export const authAtom = atom<{ auth: ReturnType<typeof useAuth> } | null>(null);
export const userAtom = atom<{ auth: ReturnType<typeof useAuth> } | null>(null);
export const jotaiStore = createStore();

/**
 * Wait for auth to be available in the Jotai store.
 * This is needed for popup windows where the auth atom may not be
 * initialized immediately when API calls are made.
 */
export const waitForAuth = async (
  timeoutMs = 5000,
  intervalMs = 50,
): Promise<{ auth: ReturnType<typeof useAuth> } | null> => {
  const startTime = Date.now();

  while (Date.now() - startTime < timeoutMs) {
    const auth = jotaiStore.get(authAtom);
    if (auth?.auth?.isLoaded && auth?.auth?.isSignedIn) {
      return auth;
    }
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }

  // Return whatever we have after timeout (may be null)
  return jotaiStore.get(authAtom);
};
